export default "__VITE_ASSET__6h3W7uEG__"